import { render, staticRenderFns } from "./historique-anamneses.html?vue&type=template&id=12d2e878&scoped=true&external"
import script from "./historique-anamneses.js?vue&type=script&lang=js&external"
export * from "./historique-anamneses.js?vue&type=script&lang=js&external"
import style0 from "./historique-anamneses.scss?vue&type=style&index=0&id=12d2e878&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d2e878",
  null
  
)

export default component.exports